import React, { useEffect, useState } from 'react';

const POLL_MS = 30_000;

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function AlertBadge() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    async function fetchCount() {
      try {
        const res = await fetch('/api/teacher/alerts/count', {
          credentials: 'include',
          headers: authHeaders(),
        });
        if (!res.ok) return;
        const data = await res.json();
        if (active) setCount(data.count);
      } catch (_) { /* swallow */ }
    }
    fetchCount();
    const id = setInterval(fetchCount, POLL_MS);
    return () => { active = false; clearInterval(id); };
  }, []);

  return (
    <span className="alert-badge">
      {count !== null && count > 0 && <span data-testid="alert-badge-dot" className="dot" />}
      <span>{count ?? '—'}</span>
    </span>
  );
}
